import type { ThemeWithoutTokens } from '../theme.types';

export const toastTokens = (theme: ThemeWithoutTokens) =>
  ({
    // toaster
    toasterOffsetTop: theme.space.layout.y.xl,
    toasterOffsetRight: theme.space.layout.x.s,
    toasterWidth: '25rem',
    toasterZIndex: theme.zIndices.toaster,
    // toast
    toastBorderLeftWidth: theme.space.component.x.xs,
    // variant
    toastInfoBorderLeftColor: theme.colors.primary.normal,
    toastWarningBorderLeftColor: theme.colors.warning.normal,
    toastErrorBorderLeftColor: theme.colors.danger.normal,
    toastSuccessBorderLeftColor: theme.colors.success.normal,
  }) as const;
